const features = [
  {
    icon: "ri-fire-line",
    color: "from-red-500 to-orange-400",
    title: "人口热力分析",
    desc: "实时掌握目标选址区域的人口密度分布与时段变化规律，精准识别高客流地带与商业黄金地段。",
    tags: ["人流密度", "时段规律", "高峰分布"],
  },
  {
    icon: "ri-user-heart-line",
    color: "from-violet-500 to-purple-400",
    title: "客群画像洞察",
    desc: "分析目标区域内消费者的年龄结构、收入层级、消费偏好与品牌认知，精准匹配品牌目标人群。",
    tags: ["人群标签", "消费能力", "品牌匹配"],
  },
  {
    icon: "ri-store-3-line",
    color: "from-blue-500 to-cyan-400",
    title: "业态构成分析",
    desc: "全面解析周边业态类型、密度与经营状态，识别互补型业态与潜在流量来源，规避同类过度竞争。",
    tags: ["业态分类", "互补分析", "密度评估"],
  },
  {
    icon: "ri-flashlight-line",
    color: "from-amber-500 to-yellow-400",
    title: "商业活力评估",
    desc: "综合营业状态、客流规模、消费频次、评价口碑等多维指标，量化目标商圈与周边区域的商业活力等级。",
    tags: ["活力指数", "消费频次", "口碑热度"],
  },
  {
    icon: "ri-road-map-line",
    color: "from-teal-500 to-emerald-400",
    title: "交通指数评估",
    desc: "分析地铁站距离、公交线路密度、停车资源、步行可达性与早晚高峰车流量，全面评估目标位置交通优势。",
    tags: ["地铁距离", "停车资源", "步行指数"],
  },
  {
    icon: "ri-trophy-line",
    color: "from-rose-500 to-pink-400",
    title: "竞品对比分析",
    desc: "自动识别周边同类竞争品牌的位置分布、销售估算与顾客评价，量化竞争压力，发现市场空白机会。",
    tags: ["竞品分布", "销售估算", "机会缺口"],
  },
];

export default function BAFeatures() {
  return (
    <section className="py-20 px-8" style={{ background: "#f4fbf7" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-emerald-600 tracking-widest uppercase mb-2 block">Core Capabilities</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">六大选址分析维度</h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">从人口热力到竞品格局，全方位评估商业选址的潜力与风险</p>
        </div>
        <div className="grid grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-slate-100 hover:border-emerald-200 transition-all cursor-pointer group">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br ${f.color} mb-4 group-hover:scale-105 transition-transform`}>
                <i className={`${f.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-slate-800 font-semibold text-base mb-2">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">{f.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {f.tags.map((t) => (
                  <span key={t} className="text-xs bg-emerald-50 border border-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Customer banner */}
        <div className="mt-12 bg-gradient-to-r from-[#0a1f2e] to-[#0d3b2a] rounded-2xl px-8 py-6 flex items-center justify-between">
          <div>
            <div className="text-emerald-300 text-xs font-semibold tracking-widest uppercase mb-1">Target Industries</div>
            <h3 className="text-white font-bold text-lg">专为商超、餐饮、零售行业深度设计</h3>
          </div>
          <div className="flex items-center gap-4">
            {[
              { icon: "ri-store-2-line", label: "商超大卖场", sub: "选址·商圈评估" },
              { icon: "ri-restaurant-line", label: "餐饮连锁", sub: "人流·竞品分析" },
              { icon: "ri-shopping-bag-line", label: "零售品牌", sub: "业态·客群匹配" },
              { icon: "ri-cup-line", label: "茶饮咖啡", sub: "活力·交通评分" },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center text-center bg-white/10 rounded-xl px-5 py-3 border border-white/15 min-w-[100px]">
                <div className="w-8 h-8 flex items-center justify-center text-emerald-300 mb-2">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="text-white font-semibold text-sm">{item.label}</div>
                <div className="text-white/50 text-xs mt-0.5">{item.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
